<template>
  <router-view/>
</template>

<style lang="scss">
@import './sass/Shared/main';
</style>
